import Axios from "./Axios";
import SummaryAPI from "../common/SummaryAPI";

const fetchUserDetails = async () => {
    try {
        const response = await Axios({
            ...SummaryAPI.userDetails
        });
        return response.data
    } catch (error) {
        console.log(error);
        return null; 
    }
};

export default fetchUserDetails;